import { BUTTON, BUTTON_SETTINGS } from '../elements/link'
import { ASSET_MOBILE, ASSET_DESKTOP } from '../elements/assets'
import { LOGO_GARDEN_CONTENT } from './logoGarden'

export const HERO_SECTION_V1 = `
...on heroSectionV1_Entry {
  id
  typeHandle
  anchorId

  backgroundColor
  subheading

  heading {
    html
  }
  description

  ${ BUTTON }
  ${ BUTTON_SETTINGS }

  ${ ASSET_DESKTOP }
  ${ ASSET_MOBILE }

  previewImageDesktop {
    url
    title
    width
    height
  }
  previewImageMobile {
    url
    title
    width
    height
  }

  videoUrl {
    url
  }

  ${ LOGO_GARDEN_CONTENT }
  logoGardenWidth
}
`